import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule} from '@angular/material/button';
import { MatProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { TextInputDialog } from './text-input-dialog.component';
import { DirectivesModule } from '../../directives/directive.module';

@NgModule({
  declarations: [
    TextInputDialog
  ],
  imports: [
    CommonModule,
    FormsModule,
    DirectivesModule,
    MatDialogModule,
    MatButtonModule,
    MatProgressSpinnerModule
  ],
  exports: [
    TextInputDialog
  ]
})
export class TextInputDialogModule { }
